// extracted by mini-css-extract-plugin
export default {"root":"SuperCollection_root__2v1bh","children":"SuperCollection_children__Zco-d","animCollapse":"SuperCollection_animCollapse__rrDvf"};